import { render, staticRenderFns } from "./ChatList_all.vue?vue&type=template&id=803188e2&scoped=true&"
import script from "./ChatList_all.vue?vue&type=script&lang=js&"
export * from "./ChatList_all.vue?vue&type=script&lang=js&"
import style0 from "./ChatList_all.vue?vue&type=style&index=0&id=803188e2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803188e2",
  null
  
)

export default component.exports